import { atom } from 'jotai'
import { DomainLv1 } from '@/pages/domain/domain-lv1/types'

/**
 * 一级领域数据 atom
 * 存储实际的数据
 */
export const domainLv1Atom = atom<DomainLv1[]>([])

/**
 * 一级领域数据加载状态 atom
 */
export const domainLv1LoadingAtom = atom<boolean>(false)

/**
 * 一级领域数据错误 atom
 */
export const domainLv1ErrorAtom = atom<Error | null>(null)

/**
 * 刷新计数器 atom，用于触发重新获取
 */
export const domainLv1RefreshCounterAtom = atom(0)

/**
 * 一级领域数据是否已初始化 atom
 * 用于确保首次加载只发起一次请求
 */
export const domainLv1InitializedAtom = atom<boolean>(false)

/**
 * 刷新一级领域数据的 atom
 */
export const refreshDomainLv1Atom = atom(
  null,
  (get, set) => {
    // 通过增加计数器来触发重新获取
    set(domainLv1RefreshCounterAtom, (prev) => prev + 1)
  }
)
